module.exports = __webpack_public_path__ + "static/media/lumi-glow.a1709bb2.jpg";